import { Collapse, ListItemButton } from '@mui/material';
import { useState } from 'react';
import Box from '@mui/material/Box';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

export const CollapseMenu = (props: {
  id: string;
  icon?: React.ReactNode;
  collapsed?: boolean;
  minimal?: boolean;
  children?: React.ReactNode;
}) => {
  const [open, setOpen] = useState(!props.collapsed);

  if (props.minimal) {
    return (
      <Box sx={{ py: 0.5 }}>
        {props.children}
        <Divider sx={{ my: 1, mx: 1.25, opacity: 0.6 }} />
      </Box>
    );
  }

  return (
    <Box>
      <ListItemButton
        onClick={() => setOpen((x) => !x)}
        sx={{
          px: 2,
          py: 1,
          mx: 1,
          borderRadius: 1.5,
          userSelect: 'none',
        }}
      >
        <ListItemText
          primary={props.id}
          primaryTypographyProps={{
            fontWeight: 700,
            fontSize: '0.8rem',
            color: 'text.secondary',
            letterSpacing: 0.2,
          }}
        />
        {open ? (
          <ExpandLess fontSize="small" color="action" />
        ) : (
          <ExpandMore fontSize="small" color="action" />
        )}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {props.children}
      </Collapse>
    </Box>
  );
};
